import { Portal } from "@gorhom/portal";
import React, { FC, JSX, ReactNode, RefObject, useCallback } from "react";
import { NativeScrollEvent, NativeSyntheticEvent, ScrollView, StyleProp, View, ViewStyle } from "react-native";
import Animated from "react-native-reanimated";
import { style as layoutStyle } from "../layout/Layout.style";
import { OFFERING_FOOTER_PORTAL_HOST, useOfferingLayout } from "./OfferingLayout";
import { style } from "./OfferingLayout.style";

interface OfferingContentStyle {
  readonly scrollView: StyleProp<ViewStyle>;
  readonly footer: StyleProp<ViewStyle>;
}

interface OfferingContentProps {
  readonly children: ReactNode;
  readonly footer?: JSX.Element;
  readonly scrollRef: RefObject<ScrollView | null>;
  readonly style?: Partial<OfferingContentStyle>;
  readonly onScroll: (event: NativeSyntheticEvent<NativeScrollEvent>) => void;
}

const OfferingContent: FC<OfferingContentProps> = ({ children, footer, scrollRef, style: customStyle, onScroll }) => {
  const { onScroll: layoutOnScroll } = useOfferingLayout();

  const handleOnScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      layoutOnScroll(event);
      onScroll(event);
    },
    [layoutOnScroll, onScroll],
  );

  return (
    <>
      <Animated.ScrollView
        // @ts-ignore
        ref={scrollRef}
        contentContainerStyle={layoutStyle.contentContainer}
        scrollEventThrottle={16}
        showsVerticalScrollIndicator={false}
        style={[style.content, customStyle?.scrollView]}
        testID="look-in-scroll-view"
        onScroll={handleOnScroll}
      >
        {children}
      </Animated.ScrollView>

      <Portal hostName={OFFERING_FOOTER_PORTAL_HOST}>
        <View style={[layoutStyle.footer, customStyle?.footer]}>{footer}</View>
      </Portal>
    </>
  );
};

export { OfferingContent };
